// Formato de textos, igual que en el prototipo (piloto oct 2026).
export const sinTildes = (s: string) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
export const emailOk = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s);
// Texto para nombres de archivo: "Pantaloneta niño" → "pantaloneta-nino".
export const paraArchivo = (s: string) => sinTildes(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const PARTICULAS = new Set(['de', 'del', 'y', 'e']);
// Nombres de personas: mayúscula inicial en cada nombre y apellido y el resto en minúscula.
// Las partículas van en minúscula salvo al inicio: "María de los Ángeles del Valle".
export function nombrePropio(s: string): string {
  const ws = String(s || '').toLocaleLowerCase('es').split(/\s+/).filter(Boolean);
  return ws.map((w, i) => i > 0 && (PARTICULAS.has(w) || (/^(la|las|los)$/.test(w) && ws[i - 1] === 'de')) ? w
    : w.replace(/(^|[-'’.(])(\p{L})/gu, (_, a: string, b: string) => a + b.toLocaleUpperCase('es'))).join(' ');
}

// Instrucciones y notas en modo oración: mayúscula al inicio de cada frase y el resto en minúscula.
// Lo que va entre comillas se guarda tal cual: es el texto exacto para estampar.
export function modoOracion(s: string): string {
  const t = String(s || '').replace(/[ \t]+/g, ' ').trim();
  let out = '', inicio = true;
  t.split(/("[^"\n]*"|“[^”\n]*”|«[^»\n]*»)/).forEach((p, k) => {
    if (k % 2) { out += p; inicio = false; return; }
    for (const ch of p.toLocaleLowerCase('es')) {
      if (inicio && /\p{L}/u.test(ch)) { out += ch.toLocaleUpperCase('es'); inicio = false; continue; }
      if (/\p{N}/u.test(ch)) inicio = false; else if (/[.!?\n]/.test(ch)) inicio = true;
      out += ch;
    }
  });
  return out;
}

// Números escritos a la colombiana o con punto decimal: "1.234,5" o "1234.5".
export function parseDec(t: string | number | null | undefined): number | null {
  const x = String(t ?? '').trim();
  if (x === '') return null;
  const v = x.includes(',') ? parseFloat(x.replace(/\./g, '').replace(',', '.')) : parseFloat(x);
  return isFinite(v) ? v : null;
}
